import { z } from 'zod';

const ANNOTATION_ID_PARAM_KEY = 'annotationId';
const PAGE_NUMBER_SEARCH_PARAM_KEY = 'page';
const SCHEMA_ID_SEARCH_PARAM_KEY = 'schemaId';

export type NeighborsParams = Record<typeof ANNOTATION_ID_PARAM_KEY, string>;

export const documentNeighborsRoute = () =>
  `/document/:${ANNOTATION_ID_PARAM_KEY}/neighbors` as const;

/** `schemaId` is the field selected on the validation screen, highlighted on every page. */
export const documentNeighborsPath = (
  annotationId: number,
  pageNumber: number,
  schemaId?: string
) =>
  `/document/${annotationId}/neighbors?${new URLSearchParams({
    [PAGE_NUMBER_SEARCH_PARAM_KEY]: String(pageNumber),
    ...(schemaId ? { [SCHEMA_ID_SEARCH_PARAM_KEY]: schemaId } : {}),
  }).toString()}`;

const neighborsParamsSchema = z.object({
  annotationId: z.coerce.number().int().positive(),
  pageNumber: z.coerce.number().int().positive(),
  schemaId: z.string().nullable(),
});

export const parseNeighborsParams = (
  params: NeighborsParams,
  search: string
) => {
  const searchParams = new URLSearchParams(search);
  return neighborsParamsSchema.safeParse({
    annotationId: params[ANNOTATION_ID_PARAM_KEY],
    pageNumber: searchParams.get(PAGE_NUMBER_SEARCH_PARAM_KEY) ?? undefined,
    schemaId: searchParams.get(SCHEMA_ID_SEARCH_PARAM_KEY),
  });
};
